interface RequestResult<T> {
	success: boolean;
	data?: T;
	error?: { message: string; name: string; stack?: string };
	index: number;
  }
  
  export const executeParallelRequests = async <T>(
	promises: Array<Promise<T>>
  ): Promise<Array<RequestResult<T>>> => {
	if (!Array.isArray(promises)) {
	  throw new Error('Input must be an array of promises');
	}
  
	return Promise.all(
	  promises.map(async (promise, index) => {
		try {
		  const data = await promise;
		  return { success: true, data, index };
		} catch (error) {
		  return {
			success: false,
			error: error instanceof Error
			  ? { message: error.message, name: error.name, stack: error.stack }
			  : { message: String(error), name: 'Unknown Error' },
			index,
		  };
		}
	  })
	);
  };